import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import TableCell from "./TableCell";
import { useDispatch, useSelector } from "react-redux";
import { customerListFields } from "../../../customerFormDataConfig";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import useColumnResizing from "../../../../../../../hooks/useColumnResizing";
import {
  setSelectedCustomer,
  selectedSelectedCustomer,
} from "../../../../../../../redux/customers/selectedCustomerSlice";

const CustomerTable = ({
  handleOpenViewModal,
  expanded,
  sortField,
  order,
  handleSort,
  dropdownLists,
}) => {
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.customers.customers);
  const selectedCustomer = useSelector(selectedSelectedCustomer);

  const {
    headerRefs,
    headerWidths,
    tableWidths,
    handleResize,
    handleResizeStop,
  } = useColumnResizing(customerListFields);

  const handleRowClick = (customer) => {
    if (
      selectedCustomer &&
      selectedCustomer.customerID === customer.customerID
    ) {
      dispatch(setSelectedCustomer(null));
    } else {
      dispatch(setSelectedCustomer(customer));
    }
  };

  const handleRowDoubleClick = (customer) => {
    dispatch(setSelectedCustomer(customer));
    handleOpenViewModal(customer);
  };

  const handleIdClick = (customer) => {
    dispatch(setSelectedCustomer(customer));
    handleOpenViewModal(customer);
  };

  return (
    <div className="overflow-x-auto">
      <div className="min-w-max mx-auto">
        <table className="table-auto">
          <thead className="sticky top-0 z-10 bg-gray-50">
            <tr>
              {customerListFields.map((field) => (
                <th
                  key={field.key}
                  className="relative pl-4 py-2 text-left text-sss-blue-sel hover:bg-cyan-100"
                >
                  <ResizableBox
                    width={headerWidths[field.key]}
                    height={20}
                    axis="x"
                    onResize={handleResize(field.key)}
                    onResizeStop={handleResizeStop(field.key)}
                    resizeHandles={["e"]}
                    handle={
                      <span
                        className="group absolute -right-4 top-0 bottom-0 w-4 cursor-col-resize"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <span className="absolute right-0 top-0 bottom-0 w-1 group-hover:bg-sss-blue-sel" />
                      </span>
                    }
                  >
                    <Tooltip title={field.tooltip || field.header}>
                      <span
                        ref={(el) => (headerRefs.current[field.key] = el)}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSort(field.key);
                        }}
                        className="block w-full whitespace-nowrap overflow-hidden text-ellipsis select-none"
                      >
                        {field.label}{" "}
                        {sortField === field.key &&
                          (order === "asc" ? "▲" : "▼")}
                      </span>
                    </Tooltip>
                  </ResizableBox>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {customers.map((customer) => {
              const customerID = Number(customer.customerID);
              const isSelected =
                selectedCustomer &&
                Number(selectedCustomer.customerID) === customerID;
              return (
                <tr
                  key={customerID}
                  onClick={() => handleRowClick(customer)}
                  onDoubleClick={() => handleRowDoubleClick(customer)}
                  className={`border-t cursor-pointer ${
                    isSelected ? "bg-cyan-100" : "bg-transparent"
                  } ${!isSelected ? "hover:bg-white hover:shadow-lg" : ""}`}
                >
                  {customerListFields.map((field) => (
                    <TableCell
                      key={field.key}
                      field={field}
                      customer={customer}
                      handleIdClick={handleIdClick}
                      width={tableWidths[field.key]}
                      dropdownLists={dropdownLists}
                    />
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerTable;
